'use client';

import React from 'react';
import styled from 'styled-components';

import { Container } from '@/components/Container';
import { ContactLayout } from '@/components/Layouts/ContactLayout';
import Section from '@/components/Section/Section';
import { SimpleCard } from '@/components/SimpleCard/SimpleCard';
import { ContactForm } from '@/features/ContactForm/ContactForm';
import { Map } from '@/features/Map/Map';
import { Video } from '@/features/Video/Video';
import { WhatIs } from '@/features/WhatIs/WhatIs';
import { WhyIs } from '@/features/WhyIs/WhyIs';
import { cards, philosophy, why } from '@/lib/about/about';
import { devices } from '@/styles/breakpoints';

export const AboutPage = () => {
  return (
    <>
      <Container>
        <Section
          title="What is Orcatec"
          description="Orcatec is your all-in-one home services management software designed to save you time, money, and boost productivity. It organizes all your tasks, synchronizes the work of your team, technicians, and clients."
        >
          <ListCards>
            {cards.map((item, idx) => (
              <SimpleCard key={idx} {...item} />
            ))}
          </ListCards>
          <Video />
        </Section>
      </Container>
      <WhyIs {...why} />
      <Container>
        <Section>
          <WhatIs {...philosophy} />
        </Section>
      </Container>

      <ContactLayout>
        <Container style={{ paddingTop: '40px' }}>
          <Wrapper>
            <ContactForm />
            <Map />
          </Wrapper>
        </Container>
      </ContactLayout>
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media only screen and ${devices.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    background-color: white;
  }
`;

const ListCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
  @media only screen and ${devices.desktop} {
    flex-direction: row;
    gap: 24px;
  }
`;

export default AboutPage;
